export const clientVersion = '1.1.27';
